import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';
import { EmptyArray, EmptyObject } from 'resources/EmptyDefaults';
import { getEntities } from 'resources/EntityData';
import { WISETACK } from 'resources/ConsumerLending/Lenders/Data';
import {
  financingDetailsListSchema,
  ENTITY_FINANCING_DETAILS,
  ENTITY_FINANCING_DETAILS_LIST,
} from 'schema/FinancingDetailsSchema';
import { index } from './Api';

export const PRE_QUALIFIED_STATUS = 'pre_qualified';
export const LOAN_REQUESTED_STATUS = 'loan_requested';
export const PENDING_STATUS = 'pending';
export const INITIATED_STATUS = 'initiated';
export const DECLINED_STATUS = 'declined';
export const EXPIRED_STATUS = 'expired';
export const MIN_JOB_AMOUNT = 500_00;
export const MAX_JOB_AMOUNT = 25_000_00;

export const getFinancingDetails = createSelector(getEntities, (entities) => {
  if (entities[ENTITY_FINANCING_DETAILS] && entities[ENTITY_FINANCING_DETAILS_LIST]) {
    return denormalize('list', financingDetailsListSchema, entities).data;
  }
  return EmptyArray;
});

export const getWisetackFinancingDetail = createSelector(
  getFinancingDetails,
  (financingDetails) =>
    financingDetails.find((financingDetail) => financingDetail.firm_name === WISETACK) || EmptyObject
);

export const getWisetackPreQualification = createSelector(
  getWisetackFinancingDetail,
  (financingDetail) => financingDetail.pre_qualification || EmptyObject
);

export const getWisetackPreQualStatusText = createSelector(
  getWisetackPreQualification,
  (preQualification) => preQualification.status_text
);

export const getWisetackPreQualStatusDate = createSelector(
  getWisetackPreQualification,
  (preQualification) => preQualification.status_date
);

export const getWisetackPreQualStatus = createSelector(
  getWisetackPreQualification,
  (preQualification) => preQualification.status || ''
);

export const fetchFinancingDetailsConfig = (serviceRequestUuid) => ({
  fetchingApiFunc: index,
  selector: getFinancingDetails,
  paramsFromProps: () => [serviceRequestUuid],
  schema: financingDetailsListSchema,
});
